import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function RememberLastRoute() {
    const location = useLocation();

    useEffect(() => {
        // HashRouter: location.pathname is al "/programs"
        const hashRoute = "#/" + location.pathname.replace(/^\//, "") + location.search;
        sessionStorage.setItem("lastRoute", hashRoute);
    }, [location.pathname, location.search]);

    return null;
}
